var map = {
	"./featured-banner.de-CH.json": 1096,
	"./featured-banner.de-DE.json": 1097,
	"./featured-banner.en-CA.json": 1098,
	"./featured-banner.en-GB.json": 1099,
	"./featured-banner.en-IN.json": 1100,
	"./featured-banner.en-ME.json": 1101,
	"./featured-banner.en-US.json": 1102,
	"./featured-banner.es-EM.json": 1103,
	"./featured-banner.es-ES.json": 1104,
	"./featured-banner.fr-BE.json": 1105,
	"./featured-banner.fr-CA.json": 1106,
	"./featured-banner.fr-CH.json": 1107,
	"./featured-banner.nl-BE.json": 1108,
	"./featured-banner.nl-NL.json": 1109,
	"./featured-banner.pl-PL.json": 1110,
	"./featured-banner.pt-BR.json": 1111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1095;